import { render, staticRenderFns } from "./ChatDialog.vue?vue&type=template&id=16d45800&scoped=true"
import script from "./ChatDialog.vue?vue&type=script&lang=js"
export * from "./ChatDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatDialog.vue?vue&type=style&index=0&id=16d45800&prod&lang=css"
import style1 from "./ChatDialog.vue?vue&type=style&index=1&id=16d45800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d45800",
  null
  
)

export default component.exports